import React from 'react';

type TextBlock = string[][];

const isTextBlock = (text: unknown): text is TextBlock =>
  Array.isArray(text) &&
  text.every(
    (paragraph) =>
      Array.isArray(paragraph) &&
      paragraph.every((line) => typeof line === 'string'),
  );

const _renderLine = (line: string[]) => line.join('  ');

const _renderParagraph = (paragraph: string[], index: number) => (
  <p key={ index }>{ _renderLine(paragraph) }</p>
);

const renderText = (text: unknown): React.ReactNode => {
  if (!isTextBlock(text)) {
    return null;
  }
  return text.map(_renderParagraph);
};

export default renderText;
